<template lang="pug">
  .modal.is-active
    .modal-background
    .modal-content
      .box
        h5.title {{ title }}
        p {{ content }}
        br
        .columns
          .column
            .level-right
              p.control
                a.button.is-black.is-rounded(@click="print" :href="ruta")
                  | Ok
</template>

<script>
  export default {
    name: 'ModalYesNo',
    props: {
      title: '',
      content: '',
      ruta: ''
    },
    methods: {
      print () {
        this.$emit('imprimirPorte', true)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/sca_Componentes/componentes/ModalPrint.vue